import React, { Component } from "react";
import { Platform } from "react-native";
import HyperLink from "./HyperLink";

export default class PhoneLink extends Component<{ number: string; style?; children?: React.ReactNode }> {
	state = {
		phoneNumber: "",
	};

	componentDidMount() {
		const { number } = this.props;
		let phoneNumber = "";
		if (Platform.OS === "ios") {
			phoneNumber = `telprompt:${number}`;
		} else {
			phoneNumber = `tel:${number}`;
		}
		this.setState({ phoneNumber });
	}

	render() {
		return (
			<HyperLink
				url={this.state.phoneNumber}
				title={this.props.number}
				notTargetBlank={true}
				style={this.props.style}
				children={this.props.children}
			/>
		);
	}
}
